import { NavLink } from 'react-router-dom';

export const NormalBreadcrumb = ({ location, text }: any) => {
	return <NavLink to={location.pathname}>{text ?? ''}</NavLink>;
};
